// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (letterId: string) => axios.get(`/letters/${letterId}/saves`);

export type LoadTempSavePayload = {
  letterId: string,
  saveId: string,
};

export const loadTempSave = ({ letterId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/letters/${letterId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/letters/saves.js